module.exports = __webpack_public_path__ + "static/media/ladd1.71e612ab.jpg";